

































































import { Component, Prop, Vue } from 'vue-property-decorator';

interface ProgressData {
  value: number;
  quantity: number;
}

@Component({
  name: 'policy-status-progress',
  components: {},
})
export default class PolicyStatusProgress extends Vue {
  @Prop({
    type: Object,
    required: true,
    default: () => {
      return { value: 0, quantity: 0 };
    },
  })
  planned!: ProgressData;

  @Prop({
    type: Object,
    required: true,
    default: () => {
      return { value: 0, quantity: 0 };
    },
  })
  open!: ProgressData;

  @Prop({
    type: Object,
    required: true,
    default: () => {
      return { value: 0, quantity: 0 };
    },
  })
  submitted!: ProgressData;

  @Prop({
    type: Object,
    required: true,
    default: () => {
      return { value: 0, quantity: 0 };
    },
  })
  policed!: ProgressData;

  @Prop({
    type: Object,
    required: true,
    default: () => {
      return { value: 0, quantity: 0 };
    },
  })
  declined!: ProgressData;

  @Prop({
    type: Object,
    required: true,
    default: () => {
      return { value: 0, quantity: 0 };
    },
  })
  canceled!: ProgressData;

  @Prop({
    type: Object,
    required: true,
    default: () => {
      return { value: 0, quantity: 0 };
    },
  })
  total!: ProgressData;

  get plannedPercent() {
    const val = (this.planned.value / this.total.value) * 100;
    return isNaN(val) ? 0 : val;
  }

  get openPercent() {
    const val = (this.open.value / this.total.value) * 100;
    return isNaN(val) ? 0 : val;
  }

  get submittedPercent() {
    const val = (this.submitted.value / this.total.value) * 100;
    return isNaN(val) ? 0 : val;
  }

  get policedPercent() {
    const val = (this.policed.value / this.total.value) * 100;
    return isNaN(val) ? 0 : val;
  }

  get declinedPercent() {
    const val = (this.declined.value / this.total.value) * 100;
    return isNaN(val) ? 0 : val;
  }

  get canceledPercent() {
    const val = ((this.canceled.value * -1) / this.total.value) * 100;
    return isNaN(val) ? 0 : val;
  }
}
